import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { kesariAnimations } from 'src/app/animation';
import { EnquiryComponent } from 'src/app/layout/enquiry/enquiry.component';


@Component({
  selector: 'app-enquiry-popup',
  templateUrl: './enquiry-popup.component.html',
  styleUrls: ['./enquiry-popup.component.scss'],
  animations: kesariAnimations,
})
export class EnquiryPopupComponent implements OnInit {
  // dayForItinery: any[];
  selectedCountry: any;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<EnquiryPopupComponent>, public dialog: MatDialog) { }

  ngOnInit(): void {
    // console.log(this.dialogData);
    this.getDaysiti();
  }
  openDialog() {
    this.dialog.open(EnquiryComponent, {
      disableClose: true,
      hasBackdrop: true,
      width: '900px',
    })
    this.closeDialog();
  }

  getDaysiti() {
    this.selectedCountry = this.dialogData;
    // console.log(this.selectedCountry, 'test');
  }
  handleImageError(event: any) {
    event.target.src = '../../assets/img/kesari_logo.png';
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  // onContact(){
  //   this.router.navigate(['/', 'users']);
  // }
}
